import { c as _c } from "react/compiler-runtime";
import { Trans, useTranslation } from 'react-i18next';
import React from 'react';
import { SectionHeadline } from '@/components/SectionHeadline';
import { InfoBoxes } from '@/components/boxes';
import IconDeferredPayment from '@/assets/icons/heroIcons/Deferred-payment.svg';
import IconMaxi from '@/assets/icons/heroIcons/Maxi.svg';
import IconPay from '@/assets/icons/heroIcons/Pay.svg';
import IconThird from '@/assets/icons/heroIcons/Third.svg';
import IconSafety from '@/assets/icons/heroIcons/Safety.svg';
import IconRewards from '@/assets/icons/heroIcons/Rewards.svg';
import { LINKS } from '@/constants/links';
import { Link } from '@/components/links';
export function Shopping() {
  const $ = _c(72);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["mallpay"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] !== t) {
    t1 = t("shopping.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <SectionHeadline className="mb-4" anchorKey="shopping.title">{t1}</SectionHeadline>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("shopping.text");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <p className="mx-auto max-w-292 text-center">{t3}</p>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <div>{t2}{t4}</div>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t("shopping.items.1.title");
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t) {
    t7 = t("shopping.items.1.text");
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <IconDeferredPayment />;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t6 || $[18] !== t7) {
    t9 = {
      title: t6,
      paragraph: t7,
      icon: t8
    };
    $[17] = t6;
    $[18] = t7;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t) {
    t10 = t("shopping.items.2.title");
    $[20] = t;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t) {
    t11 = t("shopping.items.2.text");
    $[22] = t;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <IconMaxi />;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t10 || $[26] !== t11) {
    t13 = {
      title: t10,
      paragraph: t11,
      icon: t12
    };
    $[25] = t10;
    $[26] = t11;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t) {
    t14 = t("shopping.items.3.title");
    $[28] = t;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t) {
    t15 = t("shopping.items.3.text");
    $[30] = t;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <IconPay />;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t14 || $[34] !== t15) {
    t17 = {
      title: t14,
      paragraph: t15,
      icon: t16
    };
    $[33] = t14;
    $[34] = t15;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t) {
    t18 = t("shopping.items.4.title");
    $[36] = t;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== t) {
    t19 = t("shopping.items.4.text");
    $[38] = t;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <IconThird />;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  let t21;
  if ($[41] !== t18 || $[42] !== t19) {
    t21 = {
      title: t18,
      paragraph: t19,
      icon: t20
    };
    $[41] = t18;
    $[42] = t19;
    $[43] = t21;
  } else {
    t21 = $[43];
  }
  let t22;
  if ($[44] !== t) {
    t22 = t("shopping.items.5.title");
    $[44] = t;
    $[45] = t22;
  } else {
    t22 = $[45];
  }
  let t23;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <Link analyticsParam="mallpayInsurance" testId="mallpayInsurance" to={LINKS().insurance} />;
    $[46] = t23;
  } else {
    t23 = $[46];
  }
  let t24;
  if ($[47] !== t) {
    t24 = <Trans t={t} i18nKey="shopping.items.5.text">{t23}</Trans>;
    $[47] = t;
    $[48] = t24;
  } else {
    t24 = $[48];
  }
  let t25;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <IconSafety />;
    $[49] = t25;
  } else {
    t25 = $[49];
  }
  let t26;
  if ($[50] !== t22 || $[51] !== t24) {
    t26 = {
      title: t22,
      paragraph: t24,
      icon: t25
    };
    $[50] = t22;
    $[51] = t24;
    $[52] = t26;
  } else {
    t26 = $[52];
  }
  let t27;
  if ($[53] !== t) {
    t27 = t("shopping.items.6.title");
    $[53] = t;
    $[54] = t27;
  } else {
    t27 = $[54];
  }
  let t28;
  if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <Link analyticsParam="mallpayRewards" testId="mallpayRewards" to={LINKS().rewards} />;
    $[55] = t28;
  } else {
    t28 = $[55];
  }
  let t29;
  if ($[56] !== t) {
    t29 = <Trans t={t} i18nKey="shopping.items.6.text">{t28}</Trans>;
    $[56] = t;
    $[57] = t29;
  } else {
    t29 = $[57];
  }
  let t30;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <IconRewards />;
    $[58] = t30;
  } else {
    t30 = $[58];
  }
  let t31;
  if ($[59] !== t27 || $[60] !== t29) {
    t31 = {
      title: t27,
      paragraph: t29,
      icon: t30
    };
    $[59] = t27;
    $[60] = t29;
    $[61] = t31;
  } else {
    t31 = $[61];
  }
  let t32;
  if ($[62] !== t13 || $[63] !== t17 || $[64] !== t21 || $[65] !== t26 || $[66] !== t31 || $[67] !== t9) {
    t32 = <InfoBoxes items={[t9, t13, t17, t21, t26, t31]} variant="basic" />;
    $[62] = t13;
    $[63] = t17;
    $[64] = t21;
    $[65] = t26;
    $[66] = t31;
    $[67] = t9;
    $[68] = t32;
  } else {
    t32 = $[68];
  }
  let t33;
  if ($[69] !== t32 || $[70] !== t5) {
    t33 = <div className="flex flex-col gap-12 px-4 lg:gap-16">{t5}{t32}</div>;
    $[69] = t32;
    $[70] = t5;
    $[71] = t33;
  } else {
    t33 = $[71];
  }
  return t33;
}